import { useQuery } from '@tanstack/react-query';
import { getAboutUs } from 'services/content/about-us/about.us';

export const useAboutUs = () => {
  return useQuery({
    queryKey: ['use-about-us'],
    queryFn: getAboutUs,
  });
};
